import React from "react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { HiOutlineMapPin } from "react-icons/hi2";
import useConfigSitio from "../hooks/useConfigSitio";

const FALLBACKS = {
  ubicacion_texto: "Tabancura 1091, of. 325, Vitacura, Santiago, Chile",
  horario_texto: "Lunes a viernes de 7:30 a 20:00 hrs. · Sáb y Dom cerrado.",
  instagram: "https://instagram.com/ekine.cl",
  whatsapp: "+56976604702",
  googleMaps: "https://maps.app.goo.gl/sV7o2kLH55UCWwxX6",
};

const formatInstagramHandle = (url) => {
  if (!url) return "ekine.cl";
  return url
    .replace("https://www.instagram.com/", "")
    .replace("https://instagram.com/", "")
    .replace("www.instagram.com/", "")
    .replace("instagram.com/", "")
    .replace("/", "")
    .trim() || "ekine.cl";
};

const Footer = () => {
  const { config, loading } = useConfigSitio();

  const ubicacion_texto = config?.ubicacion_texto || FALLBACKS.ubicacion_texto;
  const horario_texto = config?.horario_texto || FALLBACKS.horario_texto;
  const instagram = config?.instagram || FALLBACKS.instagram;
  const whatsappRaw = config?.whatsapp || FALLBACKS.whatsapp;
  const googleMaps = config?.googleMaps || FALLBACKS.googleMaps;

  const instagramHandle = formatInstagramHandle(instagram);
  const whatsappLink = `https://wa.me/${whatsappRaw.replace("+", "")}`;

  return (
    <footer className="bg-gray-100 border-t border-gray-300 py-8 relative text-sm">
      <div className="max-w-6xl mx-auto px-4 flex flex-col gap-8">

        {/* Fila superior */}
        <div
          className={`flex flex-col md:flex-row justify-between md:items-start items-center text-sm gap-8 text-center md:text-left ${
            loading ? "opacity-80" : ""
          }`}
        >
          {/* UBICACIÓN */}
          <div className="flex flex-col items-center md:items-start gap-1 text-[#00698F]">
            <p className="text-black font-medium">Estamos ubicados en:</p>

            <div className="flex items-center justify-center md:justify-start gap-2">
              <HiOutlineMapPin className="text-xl" />
              <a
                href={googleMaps}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                {ubicacion_texto}
              </a>
            </div>
          </div>

          {/* HORARIO */}
          <div className="flex flex-col items-center md:items-start gap-1 text-[#00698F]">
            <p className="text-black font-medium">Horario de Atención:</p>
            <p>{horario_texto}</p>
          </div>

          {/* REDES SOCIALES */}
          <div className="flex flex-col items-center md:items-start gap-2 text-[#00698F]">
            <p className="text-black font-medium">
              Síguenos en nuestras redes sociales:
            </p>

            {/* Instagram */}
            <div className="flex items-center gap-2">
              <FaInstagram className="text-xl" />
              <a
                href={instagram}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                {instagramHandle}
              </a>
            </div>

            {/* WhatsApp */}
            <div className="flex items-center gap-2">
              <FaWhatsapp className="text-xl" />
              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                ekine
              </a>
            </div>
          </div>
        </div>

        {/* Fila inferior: logo + copyright + términos */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-center border-t border-gray-300 pt-6 gap-4 w-full">
          <div className="w-full flex justify-between items-center">
            {/* Logo izquierda */}
            <div className="flex justify-start w-1/2">
              <img
                src="/Logo_EKINE.png"
                alt="EKINE"
                className="w-36 h-auto object-contain"
              />
            </div>

            {/* Copyright + Términos derecha */}
            <div className="flex flex-col items-end w-1/2 text-right gap-1">
              <p className="text-gray-600 text-sm">
                © {new Date().getFullYear()} EKINE.
              </p>
            </div>
          </div>
        </div>
            <div className="border-t border-gray-300 w-full"></div>
      </div>
        {/* Nueva sección inferior centrada */}
        <div className="pt-6 pb-2 w-full text-center text-gray-700 text-sm md:text-base leading-relaxed">
          <p className="font-medium">
            Todos los derechos reservados.
          </p>

          <a
            href="/terminos"
            className="text-[#00698F] font-semibold hover:underline"
          >
            Términos y Condiciones
          </a>
        </div>
    </footer>
  );
};

export default Footer;
